import { SearchAddressResponse } from '@/types/service-response'

export class SearchAddress {
  public constructor (
    readonly id: number,
    readonly agencyName: string,
    readonly adressNummer: string,
    readonly sortierung: string,
    readonly name: string,
    readonly vorname: string,
    readonly sperrung: string,
    readonly strasse: string,
    readonly hausnummer: string,
    readonly land: string,
    readonly plz: string,
    readonly ort: string,
    readonly region: string,
    readonly adressGruppe: string,
    readonly zusatz: string,
    readonly verantwortlich: string,
    readonly verantwortlichMobilnummer: string,
    readonly verantwortlichFestnetznummer: string,
    readonly handyPrivat: string,
    readonly handyGeschaeftlich: string,
    readonly telefonPrivate: string,
    readonly telefonGeschaeftlich: string,
    readonly mailPrivat: string,
    readonly mailGeschaeftlich: string,
    readonly genAdresse: string
  ) {}

  static createFromResponse (responseData: SearchAddressResponse[]): Array<SearchAddress> {
    return responseData.map((item: SearchAddressResponse ) => {
      return new SearchAddress(
        item.ID,
        item.AgencyName ? item.AgencyName : '',
        item.AdressNummer ? item.AdressNummer : '',
        item.Sortierung ? item.Sortierung : '',
        item.Name ? item.Name : '',
        item.Vorname ? item.Vorname : '',
        item.Sperrung ? item.Sperrung : '',
        item.Strasse ? item.Strasse : '',
        item.Hausnummer ? item.Hausnummer : '',
        item.Land ? item.Land : '',
        item.PLZ ? item.PLZ : '',
        item.Ort ? item.Ort : '',
        item.Region ? item.Region : '',
        item.AdressGruppe ? item.AdressGruppe : '',
        item.Zusatz ? item.Zusatz : '',
        item.Verantwortlich ? item.Verantwortlich : '',
        item.VerantwortlichMobilnummer ? item.VerantwortlichMobilnummer : '',
        item.VerantwortlichFestnetznummer ? item.VerantwortlichFestnetznummer : '',
        item.Handyprivat ? item.Handyprivat : '',
        item.Handygeschaeftlich ? item.Handygeschaeftlich : '',
        item.Telefonprivat ? item.Telefonprivat : '',
        item.Telefongeschaeftlich ? item.Telefongeschaeftlich : '',
          item.Mailprivat ? item.Mailprivat : '',
        item.Mailgeschaeftlich ? item.Mailgeschaeftlich : '',
        item.GenAdresse ? item.GenAdresse : ''
      )
    })
  }
}
